module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/benvi_i24_full.c7985b6c.svg";